import { apolloClient } from '../apollo';

export const localStorage = window.localStorage;
export const sessionStorage = window.sessionStorage;

export enum STORAGE_ACTION {
  KEEP_LOGGED_IN = 'KEEP_LOGGED_IN', // 자동로그인떄 사용
  CLIENT_ACCESS_TOKEN = 'CLIENT_ACCESS_TOKEN', //헤더에 들어가는 토큰
  CLIENT_REFRESH_TOKEN = 'CLIENT_REFRESH_TOKEN',
  REDIRECT_PATH = 'REDIRECT_PATH',
  TEMP_TOKEN = 'TEMP_TOKEN',
  NOT_SEEN_FOR_A_DAY = 'NOT_SEEN_FOR_A_DAY',
  NOT_SEEING_AGAIN = 'NOT_SEEING_AGAIN',
  PARTNER_EVALUTATE = 'PARTNER_EVALUTATE',
  NOT_SEEING_AGAIN_MD = 'NOT_SEEING_AGAIN_MD', // 기구설계 런칭 팝업 '다시보지 않기'
  NOT_SEEN_FOR_A_DAY_MD = 'NOT_SEEN_FOR_A_DAY_MD', // 기구설계 런칭 팝업 '하루 보지 않기'
  NOT_SEEN_FOR_A_DAY_REVIEW_TOOLTIP = 'NOT_SEEN_FOR_A_DAY_REVIEW_TOOLTIP', // GNB '거래 후기를 작성할 수 있어요!' 툴팁 '하루 보지 않기',
  PROFILE_UPDATE_SKIPPED = 'PROFILE_UPDATE_SKIPPED',
  IS_GHOST_CLIENT = 'IS_GHOST_CLIENT',
  NOT_SEEING_AGAIN_NOTICE = 'NOT_SEEING_AGAIN_NOTICE',
  NOT_SEEN_AGAIN_CAPA_VIEWER_TUTORIAL = 'NOT_SEEN_AGAIN_CAPA_VIEWER_TUTORIAL',
  TEMP_CREATE_PURCAHSE_ORDER_ID = 'TEMP_CREATE_PURCAHSE_ORDER_ID',
  TEMP_SELECTED_QUOTATION_INFO = 'TEMP_SELECTED_QUOTATION_INFO',
  TEMP_REFUND_ACCOUNT_ID = 'TEMP_REFUND_ACCOUNT_ID'
}

export enum STORAGE_ACTION_EVENT {
  NOT_SEEING_AGAIN_UPDATE = 'NOT_SEEING_AGAIN_UPDATE',
  NOT_SEEN_FOR_A_DAY_UPDATE = 'NOT_SEEN_FOR_A_DAY_UPDATE',
  NOT_SEEING_AGAIN_EVENT = 'NOT_SEEING_AGAIN_EVENT',
  NOT_SEEN_FOR_A_DAY_EVENT = 'NOT_SEEN_FOR_A_DAY_EVENT',
  NOT_SEEN_FOR_A_HALFDAY_CLOUD_TOOLTIP = 'NOT_SEEN_FOR_A_HALFDAY_CLOUD_TOOLTIP',
  NOT_SEEING_AGAIN_CLOUD_TOOLTIP = 'NOT_SEEING_AGAIN_CLOUD_TOOLTIP',
  NOT_SEEN_FOR_A_WEEK_ITP_NOTICE_POPUP = 'NOT_SEEN_FOR_A_WEEK_ITP_NOTICE_POPUP'

  /* Deprecated Key Start
  
  NOT_SEEN_FOR_A_DAY_STAMP_EVENT_END_DIALOG = 'NOT_SEEN_FOR_A_DAY_STAMP_EVENT_END_DIALOG',
  NOT_SEEING_AGAIN_STAMP_EVENT_END_DIALOG = 'NOT_SEEING_AGAIN_STAMP_EVENT_END_DIALOG'
  NOT_SEENING_AGAIN_STAMP_EXCHANGE = 'NOT_SEENING_AGAIN_STAMP_EXCHAGE',
  NOT_SEEN_FOR_A_DAY_STAMP_EXCHANGE = 'NOT_SEEN_FOR_A_DAY_STAMP_EXCHANGE',

  Deprecated Key End */
}

export const getToken: () => string | undefined = () => {
  const accessToken = localStorage.getItem(STORAGE_ACTION.CLIENT_ACCESS_TOKEN);
  if (accessToken && accessToken !== null) {
    return accessToken;
  }
  return '';
};

export const authStorageClear: () => void = () => {
  localStorage.removeItem(STORAGE_ACTION.CLIENT_ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_ACTION.CLIENT_REFRESH_TOKEN);
};

export const setStorageItem: (action: STORAGE_ACTION, data: any) => void = (
  action: STORAGE_ACTION,
  data: any
) => {
  if (action === STORAGE_ACTION.IS_GHOST_CLIENT) {
    sessionStorage.setItem(action, data);
  } else {
    localStorage.setItem(action, data);
  }
};

export const getStorageItem: (action: STORAGE_ACTION) => string | null = (
  action: STORAGE_ACTION
) => {
  if (action === STORAGE_ACTION.IS_GHOST_CLIENT) {
    return sessionStorage.getItem(action);
  } else {
    return localStorage.getItem(action);
  }
};

export const deleteStorageItem = (action: STORAGE_ACTION) => {
  if (action === STORAGE_ACTION.REDIRECT_PATH) {
    sessionStorage.removeItem(action);
  } else {
    localStorage.removeItem(action);
  }
};

export const clearStorageAll: () => void = () => {
  sessionStorage.removeItem('IS_GHOST_CLIENT');
  localStorage.removeItem(STORAGE_ACTION.KEEP_LOGGED_IN);
  localStorage.removeItem(STORAGE_ACTION.CLIENT_ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_ACTION.CLIENT_REFRESH_TOKEN);
  localStorage.removeItem(STORAGE_ACTION.REDIRECT_PATH);
  apolloClient.clearStore();
};

export const deleteSessionStorageItem: (action: STORAGE_ACTION) => void = (
  action: STORAGE_ACTION
) => {
  sessionStorage.removeItem(action);
};

const UTM_FIELDS = {
  utmSource: 'utm_source',
  utmMedium: 'utm_medium',
  utmCampaign: 'utm_campaign',
  utmTerm: 'utm_term',
  utmContent: 'utm_content'
};
export const saveUTMByQueryString = () => {
  localStorage.setItem('utm', window.location.search);
};

export const getUTMInfo = (): { [key: string]: string | null } | null => {
  const queryString = localStorage.getItem('utm');
  if (!queryString) {
    return null;
  }
  const params = new URLSearchParams(queryString);
  return {
    utmSource: params.get(UTM_FIELDS.utmSource),
    utmMedium: params.get(UTM_FIELDS.utmMedium),
    utmCampaign: params.get(UTM_FIELDS.utmCampaign),
    utmTerm: params.get(UTM_FIELDS.utmTerm),
    utmContent: params.get(UTM_FIELDS.utmContent)
  };
};

export const storage = {
  getItem: {
    /** RefreshToken for Remember me */
    get KEEP_LOGGED_IN(): string | null {
      return localStorage.getItem(STORAGE_ACTION.KEEP_LOGGED_IN);
    },
    get CLIENT_ACCESS_TOKEN(): string | null {
      return localStorage.getItem(STORAGE_ACTION.CLIENT_ACCESS_TOKEN);
    },
    get CLIENT_REFRESH_TOKEN(): string | null {
      return localStorage.getItem(STORAGE_ACTION.CLIENT_REFRESH_TOKEN);
    },
    get REDIRECT_PATH(): string | null {
      return localStorage.getItem(STORAGE_ACTION.REDIRECT_PATH);
    },
    get TEMP_TOKEN(): string | null {
      return localStorage.getItem(STORAGE_ACTION.TEMP_TOKEN);
    },
    get NOT_SEEN_FOR_A_DAY(): string | null {
      return localStorage.getItem(STORAGE_ACTION.NOT_SEEN_FOR_A_DAY);
    },
    get NOT_SEEING_AGAIN(): string | null {
      return localStorage.getItem(STORAGE_ACTION.NOT_SEEING_AGAIN);
    },
    get PARTNER_EVALUTATE(): string | null {
      return localStorage.getItem(STORAGE_ACTION.PARTNER_EVALUTATE);
    },
    get NOT_SEEING_AGAIN_MD(): string | null {
      return localStorage.getItem(STORAGE_ACTION.NOT_SEEING_AGAIN_MD);
    },
    get NOT_SEEN_FOR_A_DAY_MD(): string | null {
      return localStorage.getItem(STORAGE_ACTION.NOT_SEEN_FOR_A_DAY_MD);
    },
    get NOT_SEEN_FOR_A_DAY_REVIEW_TOOLTIP(): string | null {
      return localStorage.getItem(
        STORAGE_ACTION.NOT_SEEN_FOR_A_DAY_REVIEW_TOOLTIP
      );
    },
    get PROFILE_UPDATE_SKIPPED(): string | null {
      return localStorage.getItem(STORAGE_ACTION.PROFILE_UPDATE_SKIPPED);
    },
    get IS_GHOST_CLIENT(): string | null {
      return localStorage.getItem(STORAGE_ACTION.IS_GHOST_CLIENT);
    },
    get NOT_SEEING_AGAIN_NOTICE(): string | null {
      return localStorage.getItem(STORAGE_ACTION.NOT_SEEING_AGAIN_NOTICE);
    },
    get NOT_SEEN_AGAIN_CAPA_VIEWER_TUTORIAL(): boolean | null {
      return (
        localStorage.getItem(
          STORAGE_ACTION.NOT_SEEN_AGAIN_CAPA_VIEWER_TUTORIAL
        ) === 'true'
      );
    },
    /** for payment on mobile */
    get TEMP_CREATE_PURCAHSE_ORDER_ID(): string | null {
      return localStorage.getItem(STORAGE_ACTION.TEMP_CREATE_PURCAHSE_ORDER_ID);
    },
    /** for payment on mobile */
    get TEMP_SELECTED_QUOTATION_INFO(): TempSelectedQuotationInfo | null {
      const stringifiedValue = localStorage.getItem(
        STORAGE_ACTION.TEMP_SELECTED_QUOTATION_INFO
      );

      if (!stringifiedValue) {
        return null;
      } else {
        try {
          const parsedValue = JSON.parse(
            stringifiedValue
          ) as TempSelectedQuotationInfo;
          return parsedValue;
        } catch (e) {
          return null;
        }
      }
    },
    get TEMP_REFUND_ACCOUNT_ID(): string | null {
      return localStorage.getItem(STORAGE_ACTION.TEMP_REFUND_ACCOUNT_ID);
    },

    /** Event */

    get NOT_SEEING_AGAIN_UPDATE() {
      return localStorage.getItem(STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_UPDATE);
    },
    get NOT_SEEN_FOR_A_DAY_UPDATE() {
      return localStorage.getItem(
        STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_DAY_UPDATE
      );
    },
    get NOT_SEEING_AGAIN_EVENT() {
      return localStorage.getItem(STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_EVENT);
    },
    get NOT_SEEN_FOR_A_DAY_EVENT() {
      return localStorage.getItem(
        STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_DAY_EVENT
      );
    },
    get NOT_SEEN_FOR_A_HALFDAY_CLOUD_TOOLTIP() {
      return localStorage.getItem(
        STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_HALFDAY_CLOUD_TOOLTIP
      );
    },
    get NOT_SEEING_AGAIN_CLOUD_TOOLTIP() {
      return localStorage.getItem(
        STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_CLOUD_TOOLTIP
      );
    },
    get NOT_SEEN_FOR_A_WEEK_ITP_NOTICE_POPUP() {
      return localStorage.getItem(
        STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_WEEK_ITP_NOTICE_POPUP
      );
    }
  },
  setItem: {
    /** RefreshToken for Remember me */
    KEEP_LOGGED_IN: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.KEEP_LOGGED_IN);
      } else {
        localStorage.setItem(STORAGE_ACTION.KEEP_LOGGED_IN, newValue);
      }
    },
    CLIENT_ACCESS_TOKEN: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.CLIENT_ACCESS_TOKEN);
      } else {
        localStorage.setItem(STORAGE_ACTION.CLIENT_ACCESS_TOKEN, newValue);
      }
    },
    CLIENT_REFRESH_TOKEN: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.CLIENT_REFRESH_TOKEN);
      } else {
        localStorage.setItem(STORAGE_ACTION.CLIENT_REFRESH_TOKEN, newValue);
      }
    },
    REDIRECT_PATH: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.REDIRECT_PATH);
      } else {
        localStorage.setItem(STORAGE_ACTION.REDIRECT_PATH, newValue);
      }
    },
    TEMP_TOKEN: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.TEMP_TOKEN);
      } else {
        localStorage.setItem(STORAGE_ACTION.TEMP_TOKEN, newValue);
      }
    },
    NOT_SEEN_FOR_A_DAY: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.NOT_SEEN_FOR_A_DAY);
      } else {
        localStorage.setItem(STORAGE_ACTION.NOT_SEEN_FOR_A_DAY, newValue);
      }
    },
    NOT_SEEING_AGAIN: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.NOT_SEEING_AGAIN);
      } else {
        localStorage.setItem(STORAGE_ACTION.NOT_SEEING_AGAIN, newValue);
      }
    },
    PARTNER_EVALUTATE: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.PARTNER_EVALUTATE);
      } else {
        localStorage.setItem(STORAGE_ACTION.PARTNER_EVALUTATE, newValue);
      }
    },
    NOT_SEEING_AGAIN_MD: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.NOT_SEEING_AGAIN_MD);
      } else {
        localStorage.setItem(STORAGE_ACTION.NOT_SEEING_AGAIN_MD, newValue);
      }
    },
    NOT_SEEN_FOR_A_DAY_MD: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.NOT_SEEN_FOR_A_DAY_MD);
      } else {
        localStorage.setItem(STORAGE_ACTION.NOT_SEEN_FOR_A_DAY_MD, newValue);
      }
    },
    NOT_SEEN_FOR_A_DAY_REVIEW_TOOLTIP: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(
          STORAGE_ACTION.NOT_SEEN_FOR_A_DAY_REVIEW_TOOLTIP
        );
      } else {
        localStorage.setItem(
          STORAGE_ACTION.NOT_SEEN_FOR_A_DAY_REVIEW_TOOLTIP,
          newValue
        );
      }
    },
    PROFILE_UPDATE_SKIPPED: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.PROFILE_UPDATE_SKIPPED);
      } else {
        localStorage.setItem(STORAGE_ACTION.PROFILE_UPDATE_SKIPPED, newValue);
      }
    },
    IS_GHOST_CLIENT: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.IS_GHOST_CLIENT);
      } else {
        localStorage.setItem(STORAGE_ACTION.IS_GHOST_CLIENT, newValue);
      }
    },
    NOT_SEEING_AGAIN_NOTICE: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.NOT_SEEING_AGAIN_NOTICE);
      } else {
        localStorage.setItem(STORAGE_ACTION.NOT_SEEING_AGAIN_NOTICE, newValue);
      }
    },
    NOT_SEEN_AGAIN_CAPA_VIEWER_TUTORIAL: (newValue?: boolean) => {
      if (!newValue) {
        localStorage.removeItem(
          STORAGE_ACTION.NOT_SEEN_AGAIN_CAPA_VIEWER_TUTORIAL
        );
      } else {
        const stringifiedValue = JSON.stringify(newValue);
        localStorage.setItem(
          STORAGE_ACTION.NOT_SEEN_AGAIN_CAPA_VIEWER_TUTORIAL,
          stringifiedValue
        );
      }
    },
    /** for payment on mobile */
    TEMP_CREATE_PURCAHSE_ORDER_ID: (newValue?: string) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.TEMP_CREATE_PURCAHSE_ORDER_ID);
      } else {
        localStorage.setItem(
          STORAGE_ACTION.TEMP_CREATE_PURCAHSE_ORDER_ID,
          newValue
        );
      }
    },
    /** for payment on mobile */
    TEMP_SELECTED_QUOTATION_INFO: (newValue?: TempSelectedQuotationInfo) => {
      if (!newValue) {
        localStorage.removeItem(STORAGE_ACTION.TEMP_SELECTED_QUOTATION_INFO);
      } else {
        const stringifiedData = JSON.stringify(newValue);
        localStorage.setItem(
          STORAGE_ACTION.TEMP_SELECTED_QUOTATION_INFO,
          stringifiedData
        );
      }
    },
    TEMP_REFUND_ACCOUNT_ID: (newValue?: string) => {
      if (newValue === undefined) {
        localStorage.removeItem(STORAGE_ACTION.TEMP_REFUND_ACCOUNT_ID);
      } else {
        localStorage.setItem(STORAGE_ACTION.TEMP_REFUND_ACCOUNT_ID, newValue);
      }
    },

    /** Event */

    NOT_SEEING_AGAIN_UPDATE: (newValue?: string) => {
      if (newValue === undefined) {
        localStorage.removeItem(STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_UPDATE);
      } else {
        localStorage.getItem(STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_UPDATE);
      }
    },
    NOT_SEEN_FOR_A_DAY_UPDATE: (newValue?: string) => {
      if (newValue === undefined) {
        localStorage.removeItem(STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_DAY_UPDATE);
      } else {
        localStorage.getItem(STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_DAY_UPDATE);
      }
    },
    NOT_SEEING_AGAIN_EVENT: (newValue?: string) => {
      if (newValue === undefined) {
        localStorage.removeItem(STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_EVENT);
      } else {
        localStorage.getItem(STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_EVENT);
      }
    },
    NOT_SEEN_FOR_A_DAY_EVENT: (newValue?: string) => {
      if (newValue === undefined) {
        localStorage.removeItem(STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_DAY_EVENT);
      } else {
        localStorage.getItem(STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_DAY_EVENT);
      }
    },
    NOT_SEEN_FOR_A_HALFDAY_CLOUD_TOOLTIP: (newValue?: string) => {
      if (newValue === undefined) {
        localStorage.removeItem(
          STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_HALFDAY_CLOUD_TOOLTIP
        );
      } else {
        localStorage.getItem(
          STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_HALFDAY_CLOUD_TOOLTIP
        );
      }
    },
    NOT_SEEING_AGAIN_CLOUD_TOOLTIP: (newValue?: string) => {
      if (newValue === undefined) {
        localStorage.removeItem(
          STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_CLOUD_TOOLTIP
        );
      } else {
        localStorage.getItem(
          STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_CLOUD_TOOLTIP
        );
      }
    },
    NOT_SEEN_FOR_A_WEEK_ITP_NOTICE_POPUP: (newValue?: string) => {
      if (newValue === undefined) {
        localStorage.removeItem(
          STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_WEEK_ITP_NOTICE_POPUP
        );
      } else {
        localStorage.getItem(
          STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_WEEK_ITP_NOTICE_POPUP
        );
      }
    }
  }
};

interface TempSelectedQuotationInfo {
  rfqId: string;
  partnerId: string;
  quotationId: string;
  chatRoomId: string;
}
